export function mapItemParams(item) {
  const paramKeys = Object.keys(item.params);
  return paramKeys.map(paramKey => (paramKeys.length === 1 ? paramValueToString(item.params[paramKey]) : `${paramKey}: ${paramValueToString(item.params[paramKey])}`)) ?? [];
}

export function paramValueToString(value) {
  return Array.isArray(value) ? value.join(', ') : value;
}
